import * as Flex from "@twilio/flex-ui";
import { Tab, TaskHelper } from "@twilio/flex-ui";
import { FlexComponent } from "../../../../types/feature-loader";
import { isMultiParticipantEnabled, isParticipantTabEnabled } from "../../config";
import { ParticipantTabLabel } from "../../custom-components/ParticipantTabLabel";
import ParticipantsTab from "../../custom-components/ParticipantsTab";

interface Props {
  task: Flex.ITask;
}

export const componentName = FlexComponent.TaskCanvasTabs;
export const componentHook = function addTaskCanvasTabCustomization(flex: typeof Flex) {
  if (!isMultiParticipantEnabled() || !isParticipantTabEnabled()) return;

  flex.TaskCanvasTabs.Content.add(
    <Tab label={ParticipantTabLabel()} key="participant-tab">
      <ParticipantsTab />
    </Tab>,
    { if: ({ task }: Props) => TaskHelper.isCBMTask(task) && task.status === "accepted" }
  );
};
